<div class="feedback-step">
  <div class="step-header">
    <h3>{{ stepData.categoryTitle }}</h3>
  </div>

  <form class="questions-container" [formGroup]="formGroup">
    <div formArrayName="questionResponses">
      <div
        *ngFor="let question of stepData.questions; let i = index"
        class="question-item"
        [formGroupName]="getQuestionIndex(question.id)">
        <div class="header-with-cta mb-16">
          <div class="quetion-badge">
            <span class="badge"
              >{{ i + 1 }}/{{ stepData.questions.length }}</span
            >
            <nz-form-label nzRequired>
              <h3 class="title s-18">{{ question.question }}</h3>
            </nz-form-label>
          </div>
        </div>

        <!-- Yes/No questions with description field for "Yes" answers -->
        <div class="question-response">
          <nz-form-control
            [nzErrorTip]="getRatingScaleErrorTip(question.id)"
            [nzValidateStatus]="getRatingScaleValidationStatus(question.id)"
            [nzHasFeedback]="true">
            <div class="radio-wrapper">
              <nz-radio-group
                formControlName="ratingScale"
                class="radio-group"
                [disabled]="stepData.isViewMode"
                (ngModelChange)="onAnswerChange(question.id, $event)">
                <span nz-radio [nzValue]="3" class="box-radio">
                  <span class="radio-label">Yes</span>
                </span>
                <span nz-radio [nzValue]="5" class="box-radio">
                  <span class="radio-label">No</span>
                </span>
              </nz-radio-group>
            </div>
          </nz-form-control>

          <!-- Description field that appears when "Yes" is selected for additional support -->
          <div
            *ngIf="
              shouldShowDescription(question.id) ||
              shouldShowDescriptionInViewMode(question.id)
            "
            class="description-container">
            <nz-form-label [nzRequired]="!stepData.isViewMode"
              >Description</nz-form-label
            >
            <nz-form-control
              [nzErrorTip]="getDescriptionErrorTip(question.id)"
              [nzValidateStatus]="getDescriptionValidationStatus(question.id)"
              [nzHasFeedback]="!stepData.isViewMode">
              <textarea
                formControlName="description"
                nz-input
                rows="3"
                placeholder="Enter description"
                [disabled]="stepData.isViewMode">
              </textarea>
              <div class="mt-3 remaining-text">
                {{
                  formGroup
                    .get('questionResponses')
                    ?.get(getQuestionIndex(question.id).toString())
                    ?.get('description')?.value?.length || 0
                }}
                of 500 characters used
              </div>
            </nz-form-control>
          </div>
        </div>

        <hr class="question-divider" />
      </div>
    </div>
  </form>
</div>
